import { createClient } from "@supabase/supabase-js"

// Create a single supabase client for interacting with your database
const supabase = createClient(
  "https://waakbjennwslojbysdet.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndhYWtiamVubndzbG9qYnlzZGV0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTcxODYyNTUsImV4cCI6MjAxMjc2MjI1NX0.33RmUXAmlfA6lGAZdOqoIoiHOQIptj1CKZh4Dv7S_s4"
)

export default supabase
